export default __webpack_public_path__ + "static/media/AllerRegular.813645bf.ttf";